// S311: "Şifremi unuttum". Oturumsuz, `ProtectedShell`in DIŞINDA.
//
// 🔴 Sonuç mesajı adresin kayıtlı olup olmadığını SÖYLEMEZ: sunucu her durumda aynı
// 200'ü döndürüyor, ekran da her 200'de aynı cümleyi gösteriyor. Aksi hâlde bu form
// "şu adres sistemde var mı" sorusunun cevabını verirdi.
import { useState, type FormEvent } from 'react';
import { Link } from 'react-router-dom';
import { parolaApi, sunucuHatasi } from '../api/parola';
import {
  GirisKabugu,
  girisAltLinkCls,
  girisButonCls,
  girisEtiketCls,
  girisHataCls,
  girisInputCls,
  girisMetinCls,
} from '../components/GirisKabugu';

export function SifremiUnuttum() {
  const [email, setEmail] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [gonderildi, setGonderildi] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const adres = email.trim();
    if (!adres) {
      setError('E-posta adresinizi yazın.');
      return;
    }
    setError(null);
    setSubmitting(true);
    try {
      await parolaApi.unuttum(adres);
      setGonderildi(true);
    } catch (err) {
      setError(
        sunucuHatasi(err).durum === 429
          ? 'Çok fazla deneme. Birkaç dakika sonra tekrar deneyin.'
          : 'Bir sorun oluştu. Birkaç dakika sonra tekrar deneyin.',
      );
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <GirisKabugu baslik="Şifremi unuttum">
      {gonderildi ? (
        <p role="status" className={girisMetinCls}>
          Adres kayıtlı ve doğrulanmışsa birkaç dakika içinde bir bağlantı gelecek. Gelmezse
          yöneticinize başvurun.
        </p>
      ) : (
        <form className="flex flex-col" onSubmit={handleSubmit} noValidate>
          <label htmlFor="eposta" className={girisEtiketCls}>
            E-posta
          </label>
          <input
            id="eposta"
            type="email"
            className={`${girisInputCls} mb-3`}
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="ornek@firma.com.tr"
            autoComplete="username"
            required
          />

          {error && (
            <p role="alert" className={girisHataCls}>
              {error}
            </p>
          )}

          <button type="submit" disabled={submitting} className={girisButonCls}>
            {submitting ? 'Gönderiliyor…' : 'Bağlantı gönder'}
          </button>
        </form>
      )}

      <Link to="/login" className={girisAltLinkCls}>
        Girişe dön
      </Link>
    </GirisKabugu>
  );
}
